// extracted by mini-css-extract-plugin
export var fullHeightState = "_62-7";
export var headerCell = "_62-1";
export var loadingStateCell = "_62-4";
export var rowWrapper = "_62-3";
export var standaloneTable = "_62-8";
export var standaloneTableWithBodyFill = "_62-9";
export var stateCell = "_62-5";
export var table = "_62-0";
export var tableBodyFiller = "_62-6";
export var white = "_62-2";